export const GIT_HASH = ''
